export const onboard = {
  name: 'თქვენი ნიკნეიმი',
  email: 'ელ. ფოსტა',
  password: 'პაროლი',
  passwordRepeat: 'გაიმეორეთ პაროლი',
  forgot: 'დაგავიწყდათ პაროლი?',
  login: 'შესვლა',
  invalidTwoFactorCode: 'ორი ფაქტორიანი ავთენტიფიკაციის კოდი არასწორია',
  staleMfaChallenge: 'სესია ამოიწურა. გთხოვთ, თავიდან შეხვიდეთ.',
  signInWith: '{{social}}-ით შესვლა',
  signUpWith: '{{social}}-ით რეგისტრაცია',
  socials: {
    google: 'Google',
    facebook: 'Facebook',
    discord: 'Discord',
  },
  or: 'ან',
  noAccount: 'არ გაქვთ ანგარიში?',
  createNew: 'რეგისტრაცია',
  back: 'უკან შესვლაზე',
  emailVerified: 'ელფოსტა დადასტურდა',
  logIn: {
    title: 'შესვლა',
  },
  restore: {
    title: 'დაგავიწყდათ პაროლი?',
    subTitle: 'არ ინერვიულოთ — პაროლის აღსადგენად\n ლინკს გამოგიგზავნით.',
    send: 'გაგზავნა',
    sendAgain: 'ხელახლა გაგზავნა',
    success:
      'პაროლის აღდგენის კოდი გამოგზავნილია თქვენს ელფოსტაზე. შეამოწმეთ შეტყობინებები და შეიყვანეთ კოდი.',
  },
  register: {
    title: 'რეგისტრაცია',
    create: 'რეგისტრაცია',
    hasAccount: 'უკვე გაქვთ ანგარიში?',
    emailAlreadyUsed: 'ეს ელფოსტა უკვე დაკავსილია',
    bySign: 'ვეთანხმები',
    policy: 'გამოყენების პირობებს',
  },
  activation: {
    title: 'ელფოსტის დადასტურება',
    subTitle: 'დადასტურების ლინკი გამოგიგზავნეთ ელფოსტაზე.',
    newSent: 'აქტივაციის ლინკი გაგზავნილია',
    submit: 'ლინკის ხელახლა გაგზავნა',
    resend: 'ლინკის ხელახლა გაგზავნა',
    in: 'ში',
  },
  change: {
    success: 'პაროლი წარმატებით შეიცვალა',
    title: 'ახალი პაროლი',
    subTitle: 'ახალი პაროლი უნდა განსხვავდებოდეს\n წინა პაროლისგან.',
    submit: 'პაროლის შეცვლა',
    new: 'ახალი პაროლი',
    confirm: 'პაროლის დადასტურება',
  },
};
